export const retry = componentRoute => {
	return new Promise((resolve, reject) => {
		componentRoute()
			.then(resolve)
			.catch(error => {
				if (error.name === "ChunkLoadError") {
					window.location.reload(true);
				}

				reject(error);
			});
	});
};
